<template>
  <div class="container mt-5 text-dark">
    <h2>
      <i class="fas fa-users"></i> Listado de Grupos / Grados
    </h2>

    <!-- add new btn -->
    <router-link to="/groups/create" class="btn btn-dark mb-2 mt-3">
      <i class="fas fa-plus-circle"></i> Agregar Nuevo
    </router-link>

    <b-table
      striped :busy="isBusy"
      hover small
      responsive
      :items="items"
      :fields="fields"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template v-slot:table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Obteniendo datos...</strong>
        </div>
      </template>

      <template v-slot:cell(no)="data">
        {{data.index + 1}}
      </template>
      <template v-slot:cell(id)="data">
        <router-link :to="'/groups/details/' + data.item.id" class="btn btn-dark ml-2"  title="Detalles">        
          <i class="fas fa-info-circle"></i>
        </router-link >
        <router-link :to="'/groups/edit/' + data.item.id" class="btn btn-dark ml-2"  title="Modificar">
          <i class="fas fa-edit"></i>
        </router-link >
        <button class="btn btn-dark ml-2"  title="Eliminar" @click="deleteGroup(data.item.id)">
          <i class="fas fa-trash"></i>
        </button >
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
export default {
  computed: {
    rows() {
      return this.items.length;
    }
  },
  data() {
    return {
      items: [],
      url: this.$store.state.url,
      schoolId: this.$store.state.schoolId,

      isBusy: true,
      perPage: 50,
      currentPage: 1,
      fields: [
        { class:"text-light", key: "no", label: "#"},
        { class:"text-light", key: "name", label: "Nombre de Grupo", sortable: true },
        { class:"text-light", key: "id", label: "Acciones" }
      ]
    };
  },
  mounted() {
    this.getAll();
  },
  methods: {
    async getAll() {
      let req = await fetch(this.url + "groups/" + this.schoolId);
      this.items = await req.json();
      this.isBusy = false
    },
    async deleteGroup(id){      
      let confirmation = await this.$confirm("¿Desea eliminar este registro?", "Eliminar", "question", {confirmButtonText:"Confirmar", cancelButtonText: "Cancelar" })
      if (confirmation) {
        let req = await fetch(this.url + "group/" + id, {method:'delete'});
        if (req.ok) {
          this.getAll()
          this.$alert("Registro Eliminado Correctamente", "Hecho", "info")
        } else {          
          this.$alert("Ocurrió un error al tratar de eliminar el registro", "Error", "error")
        }
      }
    }
  }
};
</script>

<style>
</style>